import { KeyValue } from "../../responses/keyValue";
import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class ContactCommand extends AbstractConfDataCommand {
  fields?: KeyValue<string, string>[];
}